import moment from "moment";

export const setOpeningTime = date =>
  date.hour("07").minutes("15").seconds("00");

export const setClosingTime = date =>
  date.hour("23").minutes("55").seconds("00");

export const isWorkingHours = now => {
  const openingTime = setOpeningTime(now.clone());
  const closingTime = setClosingTime(now.clone());

  return (
    now.isSameOrAfter(openingTime) && now.isSameOrBefore(closingTime)
  )
};



// WEBPACK FOOTER //
// ./src/libs/datetime.js